<template>
  <tr v-if="isDep" :class="isMobile ? 'v-data-table__mobile-table-row' : ''">
    <template v-if="isMobile">
      <div class="v-data-table__mobile-row__header text-center">Gran Total</div>
      <td v-for="(count, index) of popCount" :key="index" class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">{{ headers[index + 1].text }}</div>
        <div class="v-data-table__mobile-row__cell">{{ count }}</div>
      </td>
    </template>
    <template v-else>
      <td class="text-start font-weight-bold">Gran Total</td>
      <td v-for="(total, index) of depTotal" :key="index" class="text-start font-weight-bold">{{ total }}</td>
    </template>
  </tr>

  <tr v-else-if="isPop" :class="isMobile ? 'v-data-table__mobile-table-row' : ''">
    <template v-if="isMobile">
      <div class="v-data-table__mobile-row__header text-center">Gran Total</div>
      <td v-for="(count, index) of popCount" :key="index" class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">{{ headers[index + 1].text }}</div>
        <div class="v-data-table__mobile-row__cell">{{ count }}</div>
      </td>
    </template>
    <template v-else>
      <td class="text-start font-weight-bold">Gran Total</td>
      <td v-for="(count, index) of popTotal" :key="index" class="text-start font-weight-bold">{{ count }}</td>
    </template>
  </tr>

  <tr v-else :class="isMobile ? 'v-data-table__mobile-table-row' : ''">
    <template v-if="isMobile">
      <div class="v-data-table__mobile-row__header text-center">Gran Total</div>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Mensual Nomina</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.monthlySalaryNomina }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Diario Nomina</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.dailySalaryNomina }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Mensual Ayco</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.monthlySalaryAyco }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Diario Ayco</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.dailySalaryAyco }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Monto Quincenal Ayco</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.monthSalarysAyco }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Total a recibir Ayco</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.totalSalarysAyco }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Monto Quincenal Nomina</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.monthSalarysNomina }}</div>
      </td>
      <td class="v-data-table__mobile-row">
        <div class="v-data-table__mobile-row__header">Total a recibir Nomina</div>
        <div class="v-data-table__mobile-row__cell">{{ mainTotal.totalSalarysNomina }}</div>
      </td>
    </template>
    <template v-else>
      <td class="text-start font-weight-bold">Gran Total</td>
      <td v-for="index in 5" :key="index"></td>
      <td class="text-start font-weight-bold">{{ mainTotal.monthlySalarysNomina }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.dailySalarysNomina }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.monthlySalarysAyco }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.dailySalarysAyco }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td class="text-start font-weight-bold">{{ mainTotal.monthSalarysAyco }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.extraValuesAyco }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.totalSalarysAyco }}</td>
      <td></td>
      <td class="text-start font-weight-bold">{{ mainTotal.monthSalarysNomina }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.extraValuesNomina }}</td>
      <td class="text-start font-weight-bold">{{ mainTotal.totalSalarysNomina }}</td>
    </template>
  </tr>
</template>

<script>
import { formatMoney } from '@/services/utils.js'
export default {
  props: {
    isDep: Boolean,
    isPop: Boolean,
    isMobile: Boolean,
    report: [Object, Array]
  },
  computed: {
    depTotal() {
      return this.report.map(total => formatMoney(total))
    },
    mainTotal() {
      const formatedTotals = {}
      for (const key in this.report) {
        if (this.report.hasOwnProperty(key)) {
          const element = this.report[key];
          formatedTotals[key] = formatMoney(element)
        }
      }
      return formatedTotals
    },
    popTotal() {
      return this.report
    }
  }
}
</script>

<style></style>